module.exports = __webpack_public_path__ + "static/media/Logo-avatar.51b30c2e.svg";